import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Select, MenuItem } from '@material-ui/core';
import Check from '@material-ui/icons/Check';
import Info from '@material-ui/icons/Info';
import circleTR from '../../../../assets/icons/circleTR.png';
import circleUK from '../../../../assets/icons/circleUK.png';
import InfoTooltip from '../../automs/autom/editAction/components/Info'
import SettingsService from '../../../../services/SettingsService/SettingsService';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { alertState, personalizationState, languageState } from '../../../../recoil-store/recoil-state';
import { useRecoilActions } from '../../../../recoil-store/recoil-actions';
import './Personalization.css';

function Personalization(props) {
    const { t } = useTranslation();
    const { i18n } = useTranslation();

    const label = 'CONTENT.SETTINGS.';
    // const [language, setLanguage] = useState(true);
    const [language, setLanguage] = useRecoilState(languageState);
    const [isDark, setIsDark] = useState(false);
    const [dateFormat, setDateFormat] = useState('dd/MM/yyyy');
    const [layout, setLayout] = useState('standart');
    const setAlert = useSetRecoilState(alertState);
    const actions = useRecoilActions();
    const personalization = useRecoilValue(personalizationState);

    useEffect(() => {
        fetchData();
        setLanguage("en-EN")
        // setLanguage(i18n.language)
    }, []);

    const fetchData = () => {

        if (personalization) {
            // if (personalization.pref_language === 'tr-TR') {
            //     setLanguage("tr-TR");
            // }
            if (personalization.pref_theme === 'dark') {
                setIsDark(true);
            }
            if (personalization.date_format) {
                setDateFormat(personalization.date_format);
            } else {
                if (i18n.language === 'tr-TR') {
                    setDateFormat('dd/MM/yyyy');
                } else {
                    // default english date format
                    setDateFormat('MM/dd/yyyy');
                }
            }
        }
    }

    const handleLanguageChange = (flag) => {
        if (flag) {
            setLanguage("en-EN");
            // i18n.changeLanguage('en-EN');
        } else {
            setLanguage("tr-TR");
            // i18n.changeLanguage('tr-TR');
        }
    }
    const restoreDefault = () => {
        setLanguage("en-EN");
        i18n.changeLanguage('en-EN');
        setIsDark(false);
        setDateFormat('dd/MM/yyyy');
        setLayout('standart');
        handleSave(true);
    }

    const handleSave = async (restore) => {
        let data;
        if (restore === true) {
            data = { pref_language: 'en-EN', pref_theme: 'light', date_format: 'dd/MM/yyyy' };
        } else {
            data = {
                pref_language: language,
                pref_theme: isDark ? 'dark' : 'light',
                date_format: dateFormat
            };
        }
        const res = await SettingsService.postPersonallization(data);
        if (res) {
            setAlert(alert => ({ ...alert, show: true, message: t(label + res.message), severity: res.status ? 'success' : 'error' }));
            actions.getPersonalization();
        }
        if (restore !== true) {
            i18n.changeLanguage(language);
        }
    }
    return (
        <div className="container">
            <span className="header"> {t(label + 'PERSONALIZATION')}</span>
            <hr className="seperator header-seperator" />
            <div className="input-container-row">
                <div className="col">
                    <div>
                        <span className="sub-header"> {t(label + 'LANGUAGE')}</span>
                        {/* <hr className="seperator" /> */}
                        <div className="row">
                            <button
                                className={language === "en-EN" ? "button-selected" : "button-unselected"}
                                onClick={() => handleLanguageChange(true)}>
                                {language === "en-EN" ? <Check style={{ height: "16px" }} /> : <img className="lang-icon" src={circleUK} alt="circleUK" />}
                                {t(label + 'ENGLISH')}
                            </button>
                            {/* <button
                                className={language === "tr-TR" ? "button-selected" : "button-unselected"}
                                onClick={() => handleLanguageChange(false)}>
                                {language === "tr-TR" ? <Check style={{ height: "16px" }} /> : <img className="lang-icon" src={circleTR} alt="circleTR" />}
                                {t(label + 'TURKISH')}
                            </button> */}
                        </div>
                    </div>
                    <div>
                        <span className="sub-header"> {t(label + 'DATE-FORMAT')}</span>
                        {/* <hr className="seperator" /> */}
                        <div className="row format-date-row">
                            <Select value={dateFormat} onChange={(e) => setDateFormat(e.target.value)} variant="outlined" fullWidth
                                style={{ height: 35, width: 240, color: "#46474E", fontWeight: 700, fontSize: 12, background: "transparent" }}>
                                <MenuItem style={{ color: "#46474E", fontWeight: 700, fontSize: 12 }} value="dd/MM/yyyy">DD/MM/YYYY</MenuItem>
                                <MenuItem style={{ color: "#46474E", fontWeight: 700, fontSize: 12 }} value="MM/dd/yyyy">MM/DD/YYYY</MenuItem>
                                <MenuItem style={{ color: "#46474E", fontWeight: 700, fontSize: 12 }} value="yyyy/MM/dd">YYYY/MM/DD</MenuItem>
                                <MenuItem style={{ color: "#46474E", fontWeight: 700, fontSize: 12 }} value="yyyy/dd/MM">YYYY/DD/MM</MenuItem>
                                <MenuItem style={{ color: "#46474E", fontWeight: 700, fontSize: 12 }} value="MM dd, yyyy">MM DD, YYYY</MenuItem>
                            </Select>
                        </div>
                    </div>
                    {/* <hr className="seperator" /> */}

                    {/* <div>
                        <span className="sub-header"> {t(label + 'THEME')}</span>
                        <div className="row">
                            <button className={!isDark ? "button-selected" : "button-unselected"} onClick={() => setIsDark(false)}>
                                {!isDark ? <Check style={{ height: "16px" }} /> : <span className="light-icon light-color">⬤</span>}
                                {t(label + 'LIGHT')}
                            </button>
                            <button className={isDark ? "button-selected" : "button-unselected"} onClick={() => setIsDark(true)} disabled>
                                {isDark ? <Check style={{ height: "16px" }} /> : <span className="light-icon">⬤</span>}
                                {t(label + 'DARK')}
                            </button>

                        </div>
                    </div> */}
                </div>
                {/* <div className="col">
                    <span className="sub-header"> {t(label + 'LAYOUT')}
                        <InfoTooltip value="Lorem Ipsum" placement="right">
                            <Info style={{ height: "16px", marginLeft: "5px" }} />
                        </InfoTooltip>
                    </span>
                    <hr className="seperator" />
                    <div className="row">
                        <Select value={layout} onChange={(e) => setLayout(e.target.value)} variant="outlined" fullWidth
                            style={{ height: 35, width: 240, color: "#46474E", fontWeight: 700, fontSize: 12, background: "transparent" }}>
                            <MenuItem style={{ color: "#46474E", fontWeight: 700, fontSize: 12 }} value="standart">{t(label + 'STANDARD')}
                                <span className="gray-color"> ({t(label + 'DEFAULT')})</span>
                            </MenuItem>
                        </Select>
                        <button className="button-add">
                            +
                        </button>
                    </div>
                </div> */}
            </div>
            <hr className="seperator bottom-seperator" />
            <div className="bottom-row">
                <button className="button-save" onClick={handleSave}>
                    {t(label + 'SAVE')}
                </button>
                <button className="button-restore" onClick={restoreDefault}>
                    {t(label + 'RESTORE')}
                </button>
            </div>

        </div>
    )
}
export default Personalization;